import * as React from 'react'
import * as Components from './components'
import { IReorder, IReorderItem } from './interfaces'
import { mount, retrieveFromWindow } from './utils'
import '../i18n/i18n'
import './styles/styles.scss'
import { customerOrders } from './components'
import '../react/libs/sentry/bootstrapSentry'

// Shared
mount(<Components.Nav />, '#nav')
mount(<Components.Cart />, '#cart')

// Collections
mount(<Components.CollectionsFilterBar />, '#collection-filter-bar')
mount(<Components.ProductViewToggle />, '#product-view-component')
mount(<Components.DeliveryDayPicker />, '#collections-header')
mount(<Components.CollectionsTabs />, '#collections-tabs')
mount(<Components.CollectionList />, '#collection-mount')
mount(<Components.CollectionTopNav />, '#collections-top-nav')
mount(<Components.ReviewOrderButtonWrapper />, '#collections-review-order-button')


const customerIsAllowed: boolean = retrieveFromWindow('customerIsAllowed', false)
mount(<Components.FavouriteOrdersList customerIsAllowed={customerIsAllowed} />, '#favourite-orders-container')

// Modal
mount(<Components.Modal />, '#modal')

// Terms Modal
mount(<Components.TermsModal />, '#terms-modal')

// Reorder Buttons
const reorderButtons: NodeListOf<HTMLElement> = document.querySelectorAll('.react-reorder')
const reorderData: IReorder = retrieveFromWindow('reorders', {})

for (let i: number = 0; i < reorderButtons.length; i += 1) {
  const id: number = Number(reorderButtons[i].id.split('--')[1])
  const reorderItems: IReorderItem[] = reorderData[id]
  mount(<Components.ReorderButton items={reorderItems} style='link' />, `#reorder--${id}`)
}

const mountReorderButton = (orderID: string): void => {
  if (reorderData[parseInt(orderID, 10)]) {
    mount(<Components.ReorderButton items={reorderData[parseInt(orderID, 10)]} />, `#reorder-modal--${orderID}`)
  }
}

declare const window: any
window.mountReorderButton = mountReorderButton

// Favourite Order
for (const order of customerOrders) {
  mount(<Components.FavouriteOrderTag currentOrder={order} orders={customerOrders} />, `#favourite-order-tag-${order.id}`)
}
